import { render, staticRenderFns } from "./FooterComponentKle.vue?vue&type=template&id=1e40b98f"
import script from "./FooterComponentKle.vue?vue&type=script&lang=ts"
export * from "./FooterComponentKle.vue?vue&type=script&lang=ts"
import style0 from "./FooterComponentKle.vue?vue&type=style&index=0&id=1e40b98f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports